import { render, staticRenderFns } from "./Essay.vue?vue&type=template&id=495c4f63&scoped=true"
import script from "./Essay.vue?vue&type=script&lang=js"
export * from "./Essay.vue?vue&type=script&lang=js"
import style0 from "./Essay.vue?vue&type=style&index=0&id=495c4f63&prod&lang=scss&scoped=true"
import style1 from "./Essay.vue?vue&type=style&index=1&id=495c4f63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c4f63",
  null
  
)

export default component.exports